"use client";
import React from "react";
import * as RadixSwitch from "@radix-ui/react-switch";
import cn from "classnames";

function Switch(props: RadixSwitch.SwitchProps) {
  return (
    <>
      <RadixSwitch.Root
        {...props}
        className={cn(
          `h-6 w-10 bg-[#78788029] ${props.disabled ? "data-[state=checked]:bg-[#78788029]" : "data-[state=checked]:bg-primary"} rounded-full relative outline-none cursor-pointer flex items-center highlight`,
          props.className
        )}
      >
        <RadixSwitch.Thumb className="block w-5 h-5 shadow-elevation-400 bg-white rounded-full transition-transform duration-100 translate-x-0.5 will-change-transform data-[state=checked]:translate-x-[1.15rem]" />
      </RadixSwitch.Root>
    </>
  );
}
export default Switch;
